"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceAccountType = exports.CardBrand = exports.CardType = exports.Currency = exports.PaymentMethodType = exports.PaymentFlowType = exports.PaymentStatus = void 0;
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["PENDING"] = "pending";
    PaymentStatus["CREATED"] = "created";
    PaymentStatus["AUTHORIZED"] = "authorized";
    PaymentStatus["UNAUTHORIZED"] = "unauthorized";
    PaymentStatus["CAPTURED"] = "captured";
    PaymentStatus["PROCESSING"] = "processing";
    PaymentStatus["CANCELED"] = "canceled";
    PaymentStatus["REFUND_PENDING"] = "refund_pending";
    PaymentStatus["REFUNDED"] = "refunded";
    PaymentStatus["FAILED"] = "failed";
    PaymentStatus["REFUSED"] = "refused";
    PaymentStatus["UNKNOWN"] = "unknown";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
var PaymentFlowType;
(function (PaymentFlowType) {
    PaymentFlowType["CONTACTLESS"] = "contactless";
    PaymentFlowType["SOURCE_TOKEN"] = "source_token";
    PaymentFlowType["TERMINAL"] = "terminal";
    PaymentFlowType["SESSION_ID"] = "session_id";
    PaymentFlowType["MANUAL"] = "manual";
})(PaymentFlowType || (exports.PaymentFlowType = PaymentFlowType = {}));
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["CREDIT"] = "credit";
    PaymentMethodType["DEBIT"] = "debit";
    PaymentMethodType["CASH"] = "cash";
    PaymentMethodType["GIFT"] = "gift";
    PaymentMethodType["OTHER"] = "other";
})(PaymentMethodType || (exports.PaymentMethodType = PaymentMethodType = {}));
var Currency;
(function (Currency) {
    Currency["CAD"] = "cad";
    Currency["USD"] = "usd";
})(Currency || (exports.Currency = Currency = {}));
var CardType;
(function (CardType) {
    CardType["CREDIT"] = "credit";
    CardType["DEBIT"] = "debit";
})(CardType || (exports.CardType = CardType = {}));
var CardBrand;
(function (CardBrand) {
    CardBrand["VISA"] = "visa";
    CardBrand["MASTERCARD"] = "mastercard";
    CardBrand["AMEX"] = "amex";
    CardBrand["ELO"] = "elo";
    CardBrand["JCB"] = "jcb";
    CardBrand["DINERS"] = "diners";
    CardBrand["DISCOVER"] = "discover";
    CardBrand["HIPERCARD"] = "hipercard";
    CardBrand["MAESTRO"] = "maestro";
    CardBrand["UNIONPAY"] = "unionpay";
    CardBrand["INTERAC"] = "interac";
})(CardBrand || (exports.CardBrand = CardBrand = {}));
var SourceAccountType;
(function (SourceAccountType) {
    SourceAccountType["CHECKING"] = "checking";
})(SourceAccountType || (exports.SourceAccountType = SourceAccountType = {}));
//# sourceMappingURL=enums.js.map